import { render, staticRenderFns } from "./babyloan.pug?vue&type=template&id=5969108c&lang=pug&external"
import script from "./babyloan.js?vue&type=script&lang=js&external"
export * from "./babyloan.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports